import { Component, OnInit, AfterViewInit } from "@angular/core";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolSettingsService } from "../services/adminsettings.service";
import { HttpclientService } from "../../../shared/services/httpclient.service";
import { UserService } from "../../../shared/services/user.service";
import { ConfirmationService, LazyLoadEvent } from "primeng/api";
import { ScanstationoptionsComponent } from "./scanstationoptions/scanstationoptions.component";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolemaildomainComponent } from "./schoolemaildomain/schoolemaildomain.component";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { SUPreferenceSettingsComponent } from "./supreference-settings/supreference-settings.component";
import { SchoolPortalAppRequest } from "../services/school-portal-app-request";
import * as moment from "moment";

@Component({
	templateUrl: "./preferencesettings.component.html",
	styleUrls: ["../adminsettings.css"],
	providers: [DialogService],
})
export class PreferenceSettingsComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private schoolService: SchoolService,
		private userService: UserService,
		private schoolSettingsService: SchoolSettingsService,
		private httpclientService: HttpclientService,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService
	) {}

	//Shared Data
	preferenceData = {
		SchoolID: 0,
		SchoolName: "",
	};
	schoolList: any = [];
	SUPrefData: any = [];
	EmailList: any = [];

	//Fee Menu
	feeFineData = {
		ReplaceIDCardFee: 1.5,
		TemporaryIDCardFee: 1.0,
		ChargeTemporaryIDFee: false,
	};

	//Attendance Menu
	attendanceData = {
		UsePartial: false,
		PartialPresentPercent: "N/A",
		PercentAttendance: 10,
	};

	//School E-mail Menu
	schoolEmailData = {
		SchoolDomainsAllowed: false,
		DomainName: "",
		MakeDefault: false,
		DefinedBy: 0,
	};

	//Calendar Menu
	calendarData = {
		DayType: "Fixed",
		SkipClosed: false,
		UseBell: false,
		AdjustWhenClosed: false,
	};

	lstCalendarDayType = [
		{
			DayType: "Fixed",
		},
		{
			DayType: "Rotating",
		},
	];

	//Admin Lists
	adminListData = {
		chkAdmin: false,
		chkAdvisor: false,
		chkMultiSchoolStaff: false,
		chkStaff: false,
		chkTeacher: false,
	};

	//Admin Email sig
	adminEmailData = {
		EmailSig:
			"If you have any questions, please feel free to contact Access411's support team at 1-800-574-0236 x 5 or at support@access411.com! From Access411, the makers of CAASS",
	};

	//ScanStation
	//Assumed Present Display
	assumedPresentData = {
		AssumedPresent: false,
	};
	//CAASS Mobile
	//Detention
	detentionData = {
		DetentionScanning: false,
		TardiesGenDetention: false,
		CreateDeten: -1,
	};

	lstCreateDeten = [
		{
			CreateDeten: -1,
			CreateDetenDesc: "Never",
		},
		{
			CreateDeten: 0,
			CreateDetenDesc: "Today",
		},
		{
			CreateDeten: 1,
			CreateDetenDesc: "1 Day",
		},
		{
			CreateDeten: 2,
			CreateDetenDesc: "2 Days",
		},
		{
			CreateDeten: 3,
			CreateDetenDesc: "3 Days",
		},
		{
			CreateDeten: 4,
			CreateDetenDesc: "4 Days",
		},
		{
			CreateDeten: 5,
			CreateDetenDesc: "5 Days",
		},
	];

	MFALoading: any = true;
	mfaData = {
		SchoolEnabled: false,
		DistrictEnabled: false,
	};

	securityData = {
		LockAccountAfterDays: 0,
	};

	// Portal Apps
	HasParentPortalEnabled: boolean = false;
	ScheduleTime: Date = new Date();
	ScheduleTimeDesc: string = "";

	user: any;
	errorMessage: any = "";
	Processing: any = false;

	subscription: any;
	SUPrefLoading: any = false;
	EmailLoading: any = false;
	PortalAppLoading: boolean = false;

	ngOnInit() {
		// this.loadSchoolist();
		this.user = this.userService.getCurrentUser();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	//////////////////////////////////////////
	// Load Lists
	//////////////////////////////////////////

	private loadSchoolist() {
		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.schoolList = response;
				this.preferenceData.SchoolID = this.schoolList[0].SchoolID;
				this.loadSUPrefList();
				this.loadEmailList();
			},
			(error) => {}
		);
	}

	private loadSUPrefList() {
		if (this.preferenceData.SchoolID == undefined) {
			return;
		}

		this.SUPrefLoading = true;

		var result = this.schoolSettingsService.loadSUPrefList("", this.preferenceData.SchoolID, this.user.personID);
		result.subscribe(
			(response) => {
				//Fill in fields w/ Data
				this.SUPrefData = response;

				//Reset values
				this.resetData();

				//Go through list of preferences
				//Set values if found
				this.updateData();
			},
			(error) => {
				this.SUPrefLoading = false;
			}
		);
	}

	private loadEmailList() {
		if (this.preferenceData.SchoolID == undefined) {
			return;
		}

		this.EmailLoading = true;

		var result = this.schoolSettingsService.loadEmailList("", this.user.userID, this.preferenceData.SchoolID);
		result.subscribe(
			(response) => {
				this.EmailList = response;

				var SchoolSpecificExists: any = false;

				for (var z = 0; z < this.EmailList.length; z++) {
					var next = this.EmailList[z];

					if (next.SchoolID > 0) {
						SchoolSpecificExists = true;
						break;
					}
				}

				if (SchoolSpecificExists) {
					this.updateEmail();
				} else {
					this.resetEmail();
				}
			},
			(error) => {
				this.EmailLoading = false;
			}
		);
	}

	private loadMFASettings() {
		if (this.preferenceData.SchoolID == undefined) {
			return;
		}

		this.MFALoading = true;

		var result = this.schoolSettingsService.SchoolMFASettingSelect(this.preferenceData.SchoolID);
		result.subscribe(
			(response) => {
				var resp: any = response;

				if (resp.length > 0) {
					var Data = response[0];

					this.mfaData.DistrictEnabled = Data.DistrictEnabled;

					// If District is true, override
					this.mfaData.SchoolEnabled = this.mfaData.DistrictEnabled == true ? true : Data.SchoolEnabled;
				}

				this.MFALoading = false;
			},
			(error) => {
				this.MFALoading = false;
			}
		);
	}

	private loadPortalAppSettings() {
		if (this.preferenceData.SchoolID == undefined) {
			return;
		}

		this.PortalAppLoading = true;

		var result = this.schoolSettingsService.PortalAppSettingsSelect(this.preferenceData.SchoolID);
		result.subscribe(
			(response: any) => {
				this.HasParentPortalEnabled = response.HasParentPortalEnabled;
				this.ScheduleTime = new Date(response.ScheduleTime);
				this.ScheduleTimeDesc = response.ScheduleTimeDesc;

				this.PortalAppLoading = false;
			},
			(error) => {
				this.PortalAppLoading = false;
			}
		);
	}

	//////////////////////////////////////////

	//////////////////////////////////////////
	// Event Changes
	//////////////////////////////////////////

	onSchoolChange(value) {
		if (value == undefined || value.SchoolID == undefined || value.SchoolID <= 0) {
			return;
		}

		this.preferenceData.SchoolID = value.SchoolID;
		this.preferenceData.SchoolName = value.SchoolName;

		//Update Lists
		this.loadSUPrefList();
		this.loadEmailList();
		this.loadMFASettings();
		this.loadPortalAppSettings();
	}

	//////////////////////////////////////////

	//////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////
	UpdateFeeFine() {
		if (this.feeFineData.ReplaceIDCardFee <= 0 || this.feeFineData.ReplaceIDCardFee == undefined) {
			this.feeFineData.ReplaceIDCardFee = 0;
		}

		if (this.feeFineData.TemporaryIDCardFee <= 0 || this.feeFineData.TemporaryIDCardFee == undefined) {
			this.feeFineData.TemporaryIDCardFee = 0;
		}

		this.Processing = true;

		//Call SP
		var result = this.schoolSettingsService.UpdateFeeFine(
			"",
			this.preferenceData.SchoolID,
			this.feeFineData.ReplaceIDCardFee,
			this.feeFineData.TemporaryIDCardFee,
			this.BoolToInt(this.feeFineData.ChargeTemporaryIDFee)
		);
		result.subscribe(
			(response) => {
				this.Processing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Fee/Fine Settings were Successfully Updated",
						header: "Fee/Fine Settings",
						icon: "fa",
						accept: () => {},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Update Fee/Fine Settings",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	UpdateAttendance() {
		if (this.attendanceData.PercentAttendance <= 0 || this.attendanceData.PercentAttendance == undefined) {
			this.attendanceData.PercentAttendance = 0;
		}

		if (this.attendanceData.PercentAttendance > 100) {
			this.attendanceData.PercentAttendance = 100;
		}

		this.Processing = true;

		//Call SP
		var result = this.schoolSettingsService.UpdateAttendancePref(
			"",
			this.preferenceData.SchoolID,
			this.BoolToInt(this.attendanceData.UsePartial),
			this.attendanceData.PartialPresentPercent,
			this.attendanceData.PercentAttendance
		);
		result.subscribe(
			(response) => {
				this.Processing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Attendance Settings were Successfully Updated",
						header: "Attendance Settings",
						icon: "fa",
						accept: () => {},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Update Attendance Settings",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	UpdateSchoolEmail() {
		//////////
		//Error Handling
		if (this.schoolEmailData.DomainName.replace(/ /g, "") == "") {
			this.confirmationService.confirm({
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "Domain text is empty - please enter a valid domain",
				header: "ERROR",
				icon: "fa",
				accept: () => {},
			});
			return;
		}

		//Check if .org, if not ask if user wants to continue
		if (
			!(this.schoolEmailData.DomainName.substr(this.schoolEmailData.DomainName.length - 4, 4) == ".org") &&
			!(this.schoolEmailData.DomainName.substr(this.schoolEmailData.DomainName.length - 4, 4) == ".com") &&
			!(this.schoolEmailData.DomainName.substr(this.schoolEmailData.DomainName.length - 3, 3) == ".us")
		) {
			this.confirmationService.confirm({
				acceptLabel: "Yes",
				rejectLabel: "No",
				rejectVisible: true,
				message: "Domain is not a .com, .org or .us address. Do you want to add it anyways?",
				header: "WARNING",
				icon: "fa",
				accept: () => {
					//Ask if user wants to delete old email addresses
					this.EmailKeepOrDelete();
					return;
				},
				reject: () => {
					return;
				},
			});
		} else {
			this.EmailKeepOrDelete();
		}
	}

	EmailKeepOrDelete() {
		var ref = this.dialogService.open(SchoolemaildomainComponent, {
			header: "School E-Mail Domain",
			width: "fit-content",
			data: {
				SchoolID: this.preferenceData.SchoolID,
				User: this.user,
				EmailData: this.schoolEmailData,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
			}
		});
	}

	UpdateCalendar() {
		this.Processing = true;

		//////////
		//Call SP
		var result = this.schoolSettingsService.UpdateCalendar(
			"",
			this.preferenceData.SchoolID,
			this.calendarData.DayType,
			this.BoolToInt(this.calendarData.SkipClosed),
			this.BoolToInt(this.calendarData.UseBell),
			this.BoolToInt(this.calendarData.AdjustWhenClosed)
		);
		result.subscribe(
			(response) => {
				this.Processing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Calendar Settings were Successfully Updated",
						header: "Calendar Settings",
						icon: "fa",
						accept: () => {},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Update Calendar Settings",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	UpdateAdminList() {
		this.Processing = true;

		var result = this.schoolSettingsService.UpdateAdmin(
			"",
			this.preferenceData.SchoolID,
			this.BoolToInt(this.adminListData.chkAdmin),
			this.BoolToInt(this.adminListData.chkAdvisor),
			this.BoolToInt(this.adminListData.chkStaff),
			this.BoolToInt(this.adminListData.chkMultiSchoolStaff),
			this.BoolToInt(this.adminListData.chkTeacher)
		);
		result.subscribe(
			(response) => {
				this.Processing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Administrator Lists were Successfully Updated",
						header: "Administrator Lists Settings",
						icon: "fa",
						accept: () => {},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Update Administrator Lists Settings",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	UpdateAdminEmail() {
		this.Processing = true;

		var result = this.schoolSettingsService.UpdateAdminEmail("", this.preferenceData.SchoolID, this.adminEmailData.EmailSig);
		result.subscribe(
			(response) => {
				this.Processing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Administrator E-Mail Signature was Successfully Updated",
						header: "Administrator E-Mail Signature",
						icon: "fa",
						accept: () => {},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Update Administrator E-Mail Signature",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	UpdateAssumedPresent() {
		this.Processing = true;

		var result = this.schoolSettingsService.UpdateAssumedPresent("", this.preferenceData.SchoolID, this.BoolToInt(this.assumedPresentData.AssumedPresent));
		result.subscribe(
			(response) => {
				this.Processing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Assumed Present Display was Successfully Updated",
						header: "Assumed Present Display",
						icon: "fa",
						accept: () => {},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Update Assumed Present Display Settings",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	UpdateDetentionSettings() {
		this.Processing = true;

		var result = this.schoolSettingsService.UpdateDetentionSettings(
			"",
			this.preferenceData.SchoolID,
			this.BoolToInt(this.detentionData.DetentionScanning),
			this.BoolToInt(this.detentionData.TardiesGenDetention),
			this.detentionData.CreateDeten
		);
		result.subscribe(
			(response) => {
				this.Processing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Detention Settings were Successfully Updated",
						header: "Detention Settings",
						icon: "fa",
						accept: () => {},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Update Detention Settings",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	UpdateMFA() {
		this.Processing = true;

		var result = this.schoolSettingsService.UpdateSchoolMFA(this.preferenceData.SchoolID, this.BoolToInt(this.mfaData.SchoolEnabled));
		result.subscribe(
			(response) => {
				this.Processing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "MFA Settings were Successfully Updated",
						header: "MFA Settings",
						icon: "fa",
						accept: () => {},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Update MFA Settings",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	UpdateSecuritySettings() {
		this.Processing = true;

		var result = this.schoolSettingsService.UpdateSecuritySettings(this.preferenceData.SchoolID, this.securityData.LockAccountAfterDays);
		result.subscribe(
			(response) => {
				this.Processing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Security Settings were Successfully Updated",
						header: "Security Settings",
						icon: "fa",
						accept: () => {},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Update Security Settings",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	UpdatePortalAppSettings() {
		var fsDate = moment(this.ScheduleTime).format("HH:mm:ss");

		if (String(fsDate).toLowerCase().indexOf("invalid") != -1) {
			this.errorMessage = "Invalid Schedule Time";
			return;
		}

		var parms: SchoolPortalAppRequest = {
			SchoolID: this.preferenceData.SchoolID,
			ScheduleTime: fsDate,
		};

		this.Processing = true;

		var result = this.schoolSettingsService.PortalAppDailyAbsentNotificationScheduleModify(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Portal Settings were Successfully Updated",
						header: "Portal App Settings",
						icon: "fa",
						accept: () => {},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Update Portal App Settings: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	//////////////////////////////////////////

	//////////////////////////////////////////
	// Helper Methods
	//////////////////////////////////////////
	BoolToInt(val) {
		return val ? 1 : 0;
	}

	resetEmail() {
		this.schoolEmailData.DomainName = "";
		this.schoolEmailData.MakeDefault = false;
		this.schoolEmailData.DefinedBy = 0;

		this.EmailLoading = false;
	}

	updateEmail() {
		for (var i = 0; i < this.EmailList.length; i++) {
			var next = this.EmailList[i];
			if (next.SchoolID == this.preferenceData.SchoolID) {
				this.schoolEmailData.DomainName = next.EmailProviderInfo;
				this.schoolEmailData.MakeDefault = next.IsPrimary == 1 ? true : false;
				this.schoolEmailData.DefinedBy = next.DefinedBy;
			}
		}

		this.EmailLoading = false;
	}

	resetData() {
		//Fee/Fine
		this.feeFineData.ReplaceIDCardFee = 1.5;
		this.feeFineData.TemporaryIDCardFee = 1.0;
		this.feeFineData.ChargeTemporaryIDFee = false;

		//Attendance Menu
		this.attendanceData.UsePartial = false;
		this.attendanceData.PartialPresentPercent = "N/A";
		this.attendanceData.PercentAttendance = 10;

		//School E-mail Menu
		//this.schoolEmailData.DomainName = "";
		//this.schoolEmailData.MakeDefault = false;

		//Calendar Menu
		this.calendarData.DayType = "Fixed";
		this.calendarData.SkipClosed = false;
		this.calendarData.UseBell = false;
		this.calendarData.AdjustWhenClosed = false;

		//Admin Lists
		this.adminListData.chkAdmin = false;
		this.adminListData.chkAdvisor = false;
		this.adminListData.chkMultiSchoolStaff = false;
		this.adminListData.chkStaff = false;
		this.adminListData.chkTeacher = false;

		//Admin Email sig
		this.adminEmailData.EmailSig =
			"If you have any questions, please feel free to contact Access411's support team at 1-800-574-0236 x 5 or at support@access411.com! From Access411, the makers of CAASS";

		//ScanStation
		//Assumed Present Display
		this.assumedPresentData.AssumedPresent = false;

		//CAASS Mobile
		//Detention
		this.detentionData.DetentionScanning = false;
		this.detentionData.TardiesGenDetention = false;
		this.detentionData.CreateDeten = -1;

		this.securityData.LockAccountAfterDays = 0;
	}

	updateData() {
		for (var i = 0; i < this.SUPrefData.length; i++) {
			var next = this.SUPrefData[i];

			//Fee/fine
			if (next.Category == "SCANSTATION" && next.KeyName == "IDCardFee") {
				this.feeFineData.ReplaceIDCardFee = next.KeyValue.replace("$", "");
			} else if (next.Category == "SCANSTATION" && next.KeyName == "TempIDFee") {
				this.feeFineData.TemporaryIDCardFee = next.KeyValue.replace("$", "");
			} else if (next.Category == "SCANSTATION" && next.KeyName == "ChargeTempID") {
				this.feeFineData.ChargeTemporaryIDFee = next.KeyValue == 1 ? true : false;
			}
			//Attendance
			else if (next.Category == "GENERAL" && next.KeyName == "UsePartialPresent") {
				this.attendanceData.UsePartial = next.KeyValue == 1 ? true : false;
			} else if (next.Category == "SCANSTATION" && next.KeyName == "PartialPresent") {
				this.attendanceData.PartialPresentPercent = next.KeyValue;
			} else if (next.Category == "GENERAL" && next.KeyName == "SchoolDayThreshhold") {
				this.attendanceData.PercentAttendance = next.KeyValue;
			}
			//SchoolEmail
			else if (next.Category == "General" && next.KeyName == "SchoolDomainsAllowed") {
				this.schoolEmailData.SchoolDomainsAllowed = next.KeyValue == 1 ? true : false;
			}
			//Calendar
			else if (next.Category == "CalendarSettings" && next.KeyName == "CalendarDayType") {
				if (next.KeyValue == 1) {
					this.calendarData.DayType = "Fixed";
				} else if (next.KeyValue == 2) {
					this.calendarData.DayType = "Rotating";
				}
			} else if (next.Category == "CalendarSettings" && next.KeyName == "SkipClosedDay") {
				this.calendarData.SkipClosed = next.KeyValue == 1 ? true : false;
			} else if (next.Category == "CalendarSettings" && next.KeyName == "UseSchoolDayBellSchedule") {
				this.calendarData.UseBell = next.KeyValue == 1 ? true : false;
			} else if (next.Category == "CalendarSettings" && next.KeyName == "AdjustCalendarSchoolClosed") {
				this.calendarData.AdjustWhenClosed = next.KeyValue == 1 ? true : false;
			}
			//Admin Lists
			else if (next.Category == "Admin" && next.KeyName == "chkAdmin") {
				this.adminListData.chkAdmin = next.KeyValue == 1 ? true : false;
			} else if (next.Category == "Admin" && next.KeyName == "chkAdvisor") {
				this.adminListData.chkAdvisor = next.KeyValue == 1 ? true : false;
			} else if (next.Category == "Admin" && next.KeyName == "chkStaff") {
				this.adminListData.chkStaff = next.KeyValue == 1 ? true : false;
			} else if (next.Category == "Admin" && next.KeyName == "chkMultiSchoolStaff") {
				this.adminListData.chkMultiSchoolStaff = next.KeyValue == 1 ? true : false;
			} else if (next.Category == "Admin" && next.KeyName == "chkTeacher") {
				this.adminListData.chkTeacher = next.KeyValue == 1 ? true : false;
			}
			//Admin Email Sig
			else if (next.Category == "GENERAL" && next.KeyName == "AdministratorEmailSignature") {
				this.adminEmailData.EmailSig = next.KeyValue;
			}
			//Assumed Present
			else if (next.Category == "Admin" && next.KeyName == "chkAssumedPresent") {
				this.assumedPresentData.AssumedPresent = next.KeyValue == 1 ? true : false;
			}
			//Detention
			else if (next.Category == "SCANSTATION" && next.KeyName == "DetentionMgmtEnabled") {
				this.detentionData.DetentionScanning = next.KeyValue == 1 ? true : false;
			} else if (next.Category == "GENERAL" && next.KeyName == "DetentionOnTardy") {
				this.detentionData.TardiesGenDetention = next.KeyValue == 1 ? true : false;
			} else if (next.Category == "GENERAL" && next.KeyName == "DetentionNotServedCreatedAfterXDays") {
				this.detentionData.CreateDeten = Number(next.KeyValue);
			}
			//Security
			else if (next.Category == "SECURITY" && next.KeyName == "LockAccountAfterDays") {
				this.securityData.LockAccountAfterDays = Number(next.KeyValue);
			}
		}

		this.SUPrefLoading = false;
	}

	//////////////////////////////////////////

	//////////////////////////////////////////
	// Popups
	//////////////////////////////////////////
	ScanStationOptions() {
		if (this.preferenceData.SchoolID == undefined || this.preferenceData.SchoolID <= 0) {
			return;
		}

		var ref = this.dialogService.open(ScanstationoptionsComponent, {
			header: "ScanStation Options Settings - " + this.preferenceData.SchoolName,
			width: "fit-content",
			data: {
				SchoolID: this.preferenceData.SchoolID,
				User: this.user,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
			}
		});
	}

	SUPreferences() {
		var HeaderText = "Edit Preference Settings";

		var popup_Width = (window.innerWidth - 80).toString() + "px";

		var ref = this.dialogService.open(SUPreferenceSettingsComponent, {
			header: HeaderText,
			width: popup_Width,
			data: {
				SchoolID: this.preferenceData.SchoolID,
				User: this.user,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
			}
		});
	}

	//////////////////////////////////////////

	IsLoading() {
		return this.SUPrefLoading == true || this.EmailLoading == true || this.PortalAppLoading == true || this.Processing == true;
	}
}
